import { render, staticRenderFns } from "./BoxMenuMain.vue?vue&type=template&id=323f854c&scoped=true"
import script from "./BoxMenuMain.vue?vue&type=script&lang=js"
export * from "./BoxMenuMain.vue?vue&type=script&lang=js"
import style0 from "./BoxMenuMain.vue?vue&type=style&index=0&id=323f854c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323f854c",
  null
  
)

export default component.exports